import {getDeviceId} from "../../utils/deviceId";
import {getVersionString} from "../../utils/version";

export const TraceInformation = () => {
  return <div className={'absolute bottom-16 flex flex-col items-center justify-center text-gray-400 mb-4 text-xs w-full z-0'}>
    <div>{getDeviceId()}</div>
    <div>{getVersionString()}</div>
  </div>
}